var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Add collateral",
        visible: _vm.isOpen,
        width: "10.56rem",
        "append-to-body": "",
        "close-on-click-modal": false,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpen = $event
        },
      },
    },
    [
      _c("div", { staticStyle: { padding: "0 0.22rem" } }, [
        _c(
          "div",
          {
            staticClass: "detail-item top-title",
            staticStyle: { "margin-top": "0" },
          },
          [
            _c("i", { staticClass: "el-icon-warning" }),
            _vm._v(
              "\n      You need to add collateral to to raise your collateralization ratio above the early warning threshold, or your\n      pledged UNIT will be liquidated.\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "detail-item spaceLeft" }, [
          _c("span", { staticClass: "detail-item-label" }, [
            _vm._v("Outstanding:"),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", [
              _c(
                "span",
                { staticClass: "bb" },
                [
                  _c("big-number", {
                    attrs: { number: _vm.pageData.loanAmount },
                  }),
                ],
                1
              ),
              _c("span", { staticClass: "unit" }, [_vm._v("TCash")]),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "price-value" }, [_vm._v("Price:")]),
            _vm._v(" "),
            _c("span", { staticClass: "price-value" }, [
              _vm._v("$" + _vm._s(_vm.TCASHPrice)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "price-value" }, [_vm._v("Value:")]),
            _vm._v(" "),
            _c("span", { staticClass: "price-value" }, [
              _vm._v("$" + _vm._s(_vm.calculateTotalValue)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "detail-item spaceLeft" }, [
          _c("span", { staticClass: "detail-item-label" }, [
            _vm._v("Collateral:"),
          ]),
          _vm._v(" "),
          _c(
            "span",
            [
              _c("big-number", { attrs: { number: _vm.pageData.unitAmount } }),
              _vm._v(" "),
              _c("span", { staticClass: "unit" }, [_vm._v(" UNIT")]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "detail-item spaceLeft" },
          [
            _c("span", { staticClass: "detail-item-label" }, [
              _vm._v("Add collateral :"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "balance-box" },
              [
                _c(
                  "el-input",
                  {
                    on: { input: _vm.handleInput },
                    model: {
                      value: _vm.inputVal,
                      callback: function ($$v) {
                        _vm.inputVal = $$v
                      },
                      expression: "inputVal",
                    },
                  },
                  [_c("template", { slot: "append" }, [_vm._v("UNIT")])],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-start",
                      "margin-top": "0.05rem",
                    },
                  },
                  [
                    _c("div", { staticClass: "unit" }, [
                      _vm._v("Price : $" + _vm._s(_vm.unitPrice)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "unit" }, [
                      _vm._v("Value : $" + _vm._s(_vm.calculateTotalValueUnit)),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "0.1rem" },
                attrs: { type: "text" },
                on: { click: _vm.inputMax },
              },
              [_vm._v("Max")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "detail-item spaceBetween" }, [
          _c("div", [
            _c("span", { staticClass: "detail-item-label" }, [
              _vm._v("Collateral Ratio:"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "rate" }, [
              _vm._v(_vm._s(_vm.calculateCollateralRatio()) + "%"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "detail-item-label" }, [
              _vm._v("Early warning threshold:"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "c-unit" }, [
              _c("span", { staticClass: "rate warning-threshold" }, [
                _vm._v(_vm._s(_vm.warningThresholdText)),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("Cancel")]),
          _vm._v(" "),
          _c("loading-btn", {
            attrs: {
              type: "primary",
              label: _vm.buttonLabel,
              disabled: _vm.isSubmitDisabled,
            },
            on: { clickHandle: _vm.debounceSubmit },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }